import { ICopqScrSeletor, ResumoModalidade } from "../../../../interface/ConsultaSCR";
import { currencyFormatter, percentFormatter } from "../../../../utils/formatters";
import "./CopqScrSeletor.css";

const DOMINIO_VENCIMENTOS: Record<string, string> = {
  "20": "Limite de crédito com vencimento até 360 dias",
  "40": "Limite de crédito com vencimento acima de 360 dias",
  "60": "Créditos a liberar até 360 dias",
  "80": "Créditos a liberar acima de 360 dias",
  "110": "Créditos a vencer até 30 dias",
  "120": "Créditos a vencer de 31 a 60 dias",
  "130": "Créditos a vencer de 61 a 90 dias",
  "140": "Créditos a vencer de 91 a 180 dias",
  "150": "Créditos a vencer de 181 a 360 dias",
  "160": "Créditos a vencer de 361 a 720 dias",
  "165": "Créditos a vencer de 721 a 1080 dias",
  "170": "Créditos a vencer de 1081 a 1440 dias",
  "175": "Créditos a vencer de 1441 a 1800 dias",
  "180": "Créditos a vencer de 1801 a 5400 dias",
  "190": "Créditos a vencer acima de 5400 dias",
  "199": "Créditos a vencer com prazo indeterminado",
  "205": "Créditos vencidos de 1 a 14 dias",
  "210": "Créditos vencidos de 15 a 30 dias",
  "220": "Créditos vencidos de 31 a 60 dias",
  "230": "Créditos vencidos de 61 a 90 dias",
  "240": "Créditos vencidos de 91 a 120 dias",
  "245": "Créditos vencidos de 121 a 150 dias",
  "250": "Créditos vencidos de 151 a 180 dias",
  "255": "Créditos vencidos de 181 a 240 dias",
  "260": "Créditos vencidos de 241 a 300 dias",
  "270": "Créditos vencidos de 301 a 360 dias",
  "280": "Créditos vencidos de 361 a 540 dias",
  "290": "Créditos vencidos acima de 540 dias",
  "310": "Créditos baixados como prejuízo até 12 meses",
  "320": "Créditos baixados como prejuízo há mais de 12m e até 48 meses",
  "330": "Créditos baixados como prejuízo há mais de 48 meses",
};


export const CopqScrSeletorPage = (data: ICopqScrSeletor) => {
  const scr = data?.copqScrSeletor?.resultados;
  const resumo = scr?.resumoDoCliente;
  const traduzido = scr?.resumoDoClienteTraduzido;

  const getValue = (value?: any): string => (value != null ? String(value) : "Não informado");

  return (
    <div className="scr-container">
      {/* HEADER */}
      <div className="scr-header">
        <div className="scr-header-left">
          <div className="scr-icon-box">
            <i className="pi pi-file"></i>
          </div>
          <div>
            <h1 className="scr-header-title">SCR Seletor 1 Refer Atual</h1>
            <p className="scr-header-subtitle">Período: {getValue(scr?.periodo)}</p>
          </div>
        </div>
      </div>

      {traduzido && (
        <>
          {/* ROW 1: CARDS */}
          <div className="scr-cards-grid">
            {/* Instituições */}
            <div className="scr-card scr-card-green">
              <div className="scr-card-header">
                <i className="pi pi-building scr-card-icon"></i> INSTITUIÇÕES
              </div>
              <div className="scr-card-value">{getValue(traduzido.qtdeInstituicoes)}</div>
              <div className="scr-card-label">bancos/ financeiras</div>
            </div>

            {/* Operações */}
            <div className="scr-card scr-card-green">
              <div className="scr-card-header">
                <i className="pi pi-file-edit scr-card-icon"></i> OPERAÇÕES
              </div>
              <div className="scr-card-value">{getValue(traduzido.qtdeOperacoes)}</div>
              <div className="scr-card-label">total de contratos</div>
            </div>

            {/* Risco Total */}
            <div className="scr-card scr-card-blue">
              <div className="scr-card-header">
                <i className="pi pi-dollar scr-card-icon-lg"></i> RISCO TOTAL
              </div>
              <div className="scr-card-value-lg">{currencyFormatter(String(traduzido.riscoTotal))}</div>
              <div className="scr-card-label">exposição total</div>
            </div>
          </div>

          {/* ROW 2: INFO E RESPONSABILIDADES */}
          <div className="scr-info-grid">
            {/* Informações do Cliente */}
            <div className="scr-section">
              <div className="scr-section-title">
                <div className="scr-section-title-line"></div>
                Informações do Cliente
              </div>
              <div className="scr-info-list">
                <div className="scr-info-item">
                  <span className="scr-info-label"><i className="pi pi-calendar scr-card-icon"></i> Data Base</span>
                  <span className="scr-info-value">{getValue(resumo?.dataBaseConsultada)}</span>
                </div>
                <div className="scr-info-item">
                  <span className="scr-info-label"><i className="pi pi-calendar-plus scr-card-icon"></i> Início Relacionamento</span>
                  <span className="scr-info-value">{getValue(resumo?.dataInicioRelacionamento)}</span>
                </div>
                <div className="scr-info-item">
                  <span className="scr-info-label"><i className="pi pi-file scr-card-icon"></i> Documentos Processados</span>
                  <span className="scr-info-value">{percentFormatter(resumo?.percentualDocumentosProcessados)}</span>
                </div>
                <div className="scr-info-item">
                  <span className="scr-info-label"><i className="pi pi-clock scr-card-icon"></i> Volume Processado</span>
                  <span className="scr-info-value">{percentFormatter(resumo?.percentualVolumeProcessado)}</span>
                </div>
              </div>
            </div>

            {/* Responsabilidades */}
            <div className="scr-section">
              <div className="scr-section-title">
                <div className="scr-section-title-line"></div>
                Responsabilidades
              </div>
              <div className="scr-info-list">
                <div className="scr-info-item">
                  <span className="scr-info-label">Carteira de Crédito</span>
                  <span className="scr-info-value scr-value-green">{currencyFormatter(String(traduzido.carteiradeCredito || 0))}</span>
                </div>
                <div className="scr-info-item">
                  <span className="scr-info-label">Coobrigações</span>
                  <span className="scr-info-value scr-value-green">{currencyFormatter(String(traduzido.coobrigacoes || 0))}</span>
                </div>
                <div className="scr-info-item">
                  <span className="scr-info-label">Repasses</span>
                  <span className="scr-info-value scr-value-blue">{currencyFormatter(String(traduzido.repasses || 0))}</span>
                </div>
                <div className="scr-info-item">
                  <span className="scr-info-label">Responsabilidade Total</span>
                  <span className="scr-info-value scr-value-purple">{currencyFormatter(String(traduzido.responsabilidadeTotal || 0))}</span>
                </div>
              </div>
            </div>
          </div>

          {/* ROW 3: Situação das Operações */}
          <div className="scr-section scr-section-mb">
            <div className="scr-section-title scr-section-title-mb24">
              <div className="scr-section-title-line"></div>
              Situação das Operações
            </div>
            <div className="scr-situacao-grid">
              <div>
                <div className="scr-situacao-value scr-situacao-value-green">{currencyFormatter(String(traduzido.carteiraVencer || 0))}</div>
                <div className="scr-situacao-label">
                  <i className="pi pi-check-circle scr-situacao-value-green"></i> A Vencer
                </div>
              </div>
              <div>
                <div className="scr-situacao-value scr-situacao-value-orange">{currencyFormatter(String(traduzido.carteiraVencido || 0))}</div>
                <div className="scr-situacao-label">
                  <i className="pi pi-exclamation-circle scr-situacao-value-orange"></i> Vencido
                </div>
              </div>
              <div>
                <div className="scr-situacao-value scr-situacao-value-red">{currencyFormatter(String(traduzido.prejuizo || 0))}</div>
                <div className="scr-situacao-label">
                  <i className="pi pi-exclamation-triangle scr-situacao-value-red"></i> Prejuízo
                </div>
              </div>
            </div>
          </div>

          {/* DETALHAMENTO POR PRAZO (Anexo 2) */}
          <div className="scr-detalhamento-card scr-section-mb">
            <div className="scr-detalhamento-header">
              <div className="scr-header-left">
                <div className="scr-icon-box">
                  <i className="pi pi-chart-line"></i>
                </div>
                <div>
                  <h2 className="scr-detalhamento-title">Detalhamento por Prazo</h2>
                  <p className="scr-detalhamento-subtitle">Análise temporal das operações</p>
                </div>
              </div>
              <div className="scr-detalhamento-periodo">
                <i className="pi pi-clock"></i>
                <span>Período: {getValue(scr?.periodo)}</span>
              </div>
            </div>

            <div className="scr-detalhamento-card">
              <div className="scr-detalhamento-card-header">
                <div className="scr-icon-box-sm">
                  <i className="pi pi-arrow-up-right"></i>
                </div>
                <div>
                  <h3 className="scr-detalhamento-card-title">Carteira a Vencer</h3>
                  <p className="scr-detalhamento-card-subtitle">Distribuição por prazo</p>
                </div>
              </div>

              <div className="scr-info-list">
                <div className="scr-bar-container">
                  <div className="scr-bar-header">
                    <span>Até 30 dias / Vencidos até 14 dias</span>
                    <span className="scr-bar-value scr-situacao-value-green">{currencyFormatter(String(traduzido.carteiraVencerAte30diasVencidosAte14dias || 0))}</span>
                  </div>
                  <div className="scr-bar-track">
                    <div className="scr-bar-fill" style={{ width: "18%", backgroundColor: "#10b981" }}></div>
                  </div>
                </div>

                <div className="scr-bar-container">
                  <div className="scr-bar-header">
                    <span>31 a 60 dias</span>
                    <span className="scr-bar-value" style={{ color: "#0d9488" }}>{currencyFormatter(String(traduzido.carteiraVencer31a60dias || 0))}</span>
                  </div>
                  <div className="scr-bar-track">
                    <div className="scr-bar-fill" style={{ width: "8%", backgroundColor: "#0d9488" }}></div>
                  </div>
                </div>

                <div className="scr-bar-container">
                  <div className="scr-bar-header">
                    <span>61 a 90 dias</span>
                    <span className="scr-bar-value" style={{ color: "#2563eb" }}>{currencyFormatter(String(traduzido.carteiraVencer61a90dias || 0))}</span>
                  </div>
                  <div className="scr-bar-track">
                    <div className="scr-bar-fill" style={{ width: "12%", backgroundColor: "#2563eb" }}></div>
                  </div>
                </div>

                <div className="scr-bar-container">
                  <div className="scr-bar-header">
                    <span>91 a 180 dias</span>
                    <span className="scr-bar-value" style={{ color: "#9333ea" }}>{currencyFormatter(String(traduzido.carteiraVencer91a180dias || 0))}</span>
                  </div>
                  <div className="scr-bar-track">
                    <div className="scr-bar-fill" style={{ width: "25%", backgroundColor: "#9333ea" }}></div>
                  </div>
                </div>

                <div className="scr-bar-container">
                  <div className="scr-bar-header">
                    <span>181 a 360 dias</span>
                    <span className="scr-bar-value" style={{ color: "#6366f1" }}>{currencyFormatter(String(traduzido.carteiraVencer181a360dias || 0))}</span>
                  </div>
                  <div className="scr-bar-track">
                    <div className="scr-bar-fill" style={{ width: "35%", backgroundColor: "#6366f1" }}></div>
                  </div>
                </div>

                <div className="scr-bar-container scr-bar-container-last">
                  <div className="scr-bar-header">
                    <span>Acima de 360 dias</span>
                    <span className="scr-bar-value" style={{ color: "#e11d48" }}>{currencyFormatter(String(traduzido.carteiraVencerAcima360dias || 0))}</span>
                  </div>
                  <div className="scr-bar-track">
                    <div className="scr-bar-fill" style={{ width: "65%", backgroundColor: "#e11d48" }}></div>
                  </div>
                </div>
              </div>

              <div className="scr-TotalVencer-container">
                <span className="scr-TotalVencer-label">Total a Vencer</span>
                <span className="scr-TotalVencer-value">{currencyFormatter(String(traduzido.carteiraVencer || 0))}</span>
              </div>
            </div>
          </div>
        </>
      )}
      <br />

      {/* Limites de Crédito */}
      {traduzido && (
        <div className="scr-section scr-section-mb">
          <div className="scr-section-title scr-section-title-mb24">
            <div className="scr-section-title-line"></div>
            Limites de Crédito
          </div>
          <div className="scr-situacao-grid">
            <div>
              <div className="scr-situacao-value" style={{ color: "#10b981" }}>{currencyFormatter(String(traduzido.limitesdeCredito || 0))}</div>
              <div className="scr-situacao-label">
                <i className="pi pi-chart-line" style={{ color: "#10b981" }}></i> Total
              </div>
            </div>
            <div>
              <div className="scr-situacao-value" style={{ color: "#183462" }}>{currencyFormatter(String(traduzido.limitesdeCreditoAte360dias || 0))}</div>
              <div className="scr-situacao-label">
                <i className="pi pi-clock" style={{ color: "#183462" }}></i> Até 360 dias
              </div>
            </div>
            <div>
              <div className="scr-situacao-value" style={{ color: "#183462" }}>{currencyFormatter(String(traduzido.limitesdeCreditoAcima360dias || 0))}</div>
              <div className="scr-situacao-label">
                <i className="pi pi-clock" style={{ color: "#183462" }}></i> Acima 360 dias
              </div>
            </div>
          </div>
        </div>
      )}

      <br />

      {(!scr || !resumo) && (
        <p>Nenhum dado encontrado para esta consulta</p>
      )}

      {resumo?.listaDeResumoDasOperacoes && resumo.listaDeResumoDasOperacoes.length > 0 && (
        <div className="scr-modalidades-section scr-section-mb">
          <div className="scr-detalhamento-header">
            <div className="scr-header-left">
              <div className="scr-icon-box">
                <i className="pi pi-sitemap"></i>
              </div>
              <div>
                <h2 className="scr-detalhamento-title">Detalhamento das Operações por Prazo</h2>
                <p className="scr-detalhamento-subtitle">Visão detalhada por modalidade e código de vencimento</p>
              </div>
            </div>
          </div>

          <div className="scr-info-list pb-2">
            {resumo.listaDeResumoDasOperacoes.map((op, opIdx) => {
              const valorTotalModalidade = op.listaDeVencimentos.reduce((sum, v) => sum + Number(v.valorVencimento), 0);
              const modalidadeData = scr?.resumoModalidade?.find((m: ResumoModalidade) => m.modalidade === op.modalidade);
              const descModalidade = modalidadeData ? (modalidadeData.subdominio || modalidadeData.dominio) : "Operação";

              const vencimentosSorted = [...op.listaDeVencimentos].sort((a, b) => {
                const numA = parseInt(a.codigoVencimento?.replace('v', '') || '0', 10);
                const numB = parseInt(b.codigoVencimento?.replace('v', '') || '0', 10);
                return numA - numB;
              });

              return (
                <div key={opIdx} className="scr-modalidade-card">
                  <div className="scr-modalidade-header">
                    <div className="scr-modalidade-title">
                      <i className="pi pi-tag"></i> {descModalidade} (cód. {op.modalidade})
                    </div>
                    <div className="scr-modalidade-total">
                      {currencyFormatter(String(valorTotalModalidade))}
                    </div>
                  </div>

                  <div className="scr-info-list" style={{ gap: "8px" }}>
                    {vencimentosSorted.map((venc, vIdx) => {
                      const codeStr = venc.codigoVencimento?.replace('v', '') || '';
                      const codeDesc = DOMINIO_VENCIMENTOS[codeStr] || "Código Desconhecido";
                      const codeNum = parseInt(codeStr, 10);
                      const isVencido = codeNum >= 200 && codeNum < 300;
                      const isPrejuizo = codeNum >= 300;

                      let valueClass = "scr-modalidade-item-value-avencer";
                      if (isVencido || isPrejuizo) valueClass = "scr-modalidade-item-value-vencido";

                      return (
                        <div key={vIdx} className="scr-modalidade-item">
                          <div className="scr-modalidade-item-left">
                            <span className="scr-modalidade-item-desc">{codeDesc}</span>
                          </div>
                          <div className={valueClass}>
                            {currencyFormatter(String(venc.valorVencimento))}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
